module.exports = __webpack_public_path__ + "img/5.a71e396f.png";